(() => {
  'use strict';
  const root = document.querySelector('body[data-mobile-ingredient-navigation] [data-compact-evidence]');
  if (!root) return;
  const returnButtons = [...root.querySelectorAll('[data-ingredient-return]')];
  const areas = root.querySelector('.evidence-areas');
  returnButtons.forEach(button => button.addEventListener('click', () => {
    if (!window.matchMedia('(max-width:700px)').matches) return;
    const selected = root.querySelector('[data-map-ingredients]:not([hidden]) [data-map-ingredient][aria-pressed="true"]');
    if (!selected) return;
    selected.focus({preventScroll:true});
    areas.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  }));
})();
